import { type ReactNode } from 'react';
import styles from './Tabs.module.css';

export interface TabDef {
  id: string;
  label: string;
  count?: number;
}

export interface TabsProps {
  tabs: TabDef[];
  activeId: string;
  onSelect: (id: string) => void;
  small?: boolean;
}

export function Tabs({ tabs, activeId, onSelect, small = false }: TabsProps) {
  return (
    <div role="tablist" className={styles.tabBar}>
      {tabs.map((t) => {
        const active = t.id === activeId;
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`${styles.tab} ${small ? styles.tabSmall : ''} ${active ? styles.active : ''}`}
            onClick={() => onSelect(t.id)}
          >
            {t.label}
            {typeof t.count === 'number' ? <span className={styles.count}>{t.count}</span> : null}
          </button>
        );
      })}
    </div>
  );
}

export function TabPanel({ children }: { children: ReactNode }) {
  return <div className={styles.panel}>{children}</div>;
}
